module.exports = __webpack_public_path__ + "media/images/entrepreneur-41f6a1ed3a6f7d609eb2748e95561813.png";